import { useQuery } from "@tanstack/react-query";
import { fetchAllPagesFromPaginatedEndpoint } from "../utils/teamUsersBackend";
import { resolvePaginatedTotal } from "../utils/teamUsersCatalog";

/**
 * Loads an unfiltered user catalog so Title / Role / Portal Access options stay
 * stable when table filters change (same behavior as the Innovation Lab prototype).
 * Also exposes totalUsers for dashboard metrics that must ignore table filters.
 */
export function useTeamUsersFilterCatalog({
  queryKey,
  fetchPage,
  enabled = true,
  staleTime = 5 * 60 * 1000,
}) {
  const baseKey = Array.isArray(queryKey) ? queryKey : [queryKey];
  const canFetch = Boolean(enabled && fetchPage);

  const totalsQuery = useQuery({
    queryKey: [...baseKey, "unfiltered-total"],
    enabled: canFetch,
    staleTime,
    queryFn: () => fetchPage(1),
  });

  const catalogQuery = useQuery({
    queryKey: [...baseKey, "filter-catalog"],
    enabled: canFetch,
    staleTime,
    queryFn: () => fetchAllPagesFromPaginatedEndpoint(fetchPage),
  });

  const catalogItems = catalogQuery.data?.items ?? [];
  const totalUsers =
    resolvePaginatedTotal(totalsQuery.data) ??
    resolvePaginatedTotal(catalogQuery.data);

  return {
    catalogItems,
    totalUsers,
    isCatalogLoading: catalogQuery.isLoading,
    isTotalsLoading: totalsQuery.isLoading,
    catalogQuery,
    totalsQuery,
  };
}
